module.exports = __webpack_public_path__ + "img/columns.8d682612.svg";